/* souvenir-preview-upload.js
 * Provides window.SOUVENIR_UPLOAD_PREVIEW(pngDataUrl, properties) -> Promise<string url>.
 * The app calls this on "Add to basket" with a PRINT-RESOLUTION PNG and stores the
 * returned URL in the line-item property "_print_url" (also "_preview_url"). With the
 * Gelato app, set the print-file field name to "_print_url" (see README → Gelato).
 * The order also carries "_print_spec" (JSON) to regenerate the file server-side.
 *
 * Pick ONE implementation below and fill in the placeholders.
 * ------------------------------------------------------------------------- */

/* ===== OPTION A — Cloudinary unsigned upload (no backend, quickest) =========
 * 1. Create a free Cloudinary account.
 * 2. Settings → Upload → add an UNSIGNED upload preset.
 * 3. Put your cloud name + preset below.
 */
window.SOUVENIR_UPLOAD_PREVIEW = async function (dataUrl, properties) {
  const CLOUD_NAME = "djpbp9zre";
  const UPLOAD_PRESET = "itzvdehc";

  const blob = await (await fetch(dataUrl)).blob();
  const form = new FormData();
  form.append("file", blob);
  form.append("upload_preset", UPLOAD_PRESET);
  // helps you find the order later
  form.append("context", "caption=" + (properties.Caption || "") + "|size=" + (properties.Size || ""));

  const res = await fetch("https://api.cloudinary.com/v1_1/" + CLOUD_NAME + "/image/upload", {
    method: "POST",
    body: form,
  });
  if (!res.ok) throw new Error("Cloudinary upload failed");
  const json = await res.json();
  return json.secure_url;
};

/* ===== OPTION B — Shopify Files via an App Proxy (keeps it in Shopify) ======
 * Requires a small backend (a Shopify app / serverless function) exposed at an
 * App Proxy path, which performs a stagedUploadsCreate + fileCreate against the
 * Admin GraphQL API and returns the file URL. Replace the function above with:
 *
 * window.SOUVENIR_UPLOAD_PREVIEW = async function (dataUrl) {
 *   const blob = await (await fetch(dataUrl)).blob();
 *   const form = new FormData();
 *   form.append("file", blob, "souvenir-preview.png");
 *   const res = await fetch("/apps/souvenir/upload", { method: "POST", body: form });
 *   const { url } = await res.json();
 *   return url;
 * };
 *
 * See README → "Preview image upload" for the Admin API mutations to implement.
 */
